module.exports = __webpack_public_path__ + "img/index-left.1b995779.png";